// Client for the Budget Optimiser.
//
// Reads, plus the seller's own decisions and their own monthly budget. The apply
// call is a dry run by default and is refused while writing to Amazon is off —
// the response names which locks are closed.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/budget-optimiser`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon Ads not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  if (data.connected === false) throw new NotConnectedError(data.reason);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

export const getPlan = (token) => call(`${BASE}/plan`, { headers: headers(token) });
export const getActions = (token, params) =>
  call(`${BASE}/actions?${query(params)}`, { headers: headers(token) });
export const getWatch = (token) => call(`${BASE}/watch`, { headers: headers(token) });
export const getChanges = (token, params) =>
  call(`${BASE}/changes?${query(params)}`, { headers: headers(token) });
export const getSettings = (token) =>
  call(`${BASE}/settings`, { headers: headers(token) });
export const saveSettings = (token, body) =>
  call(`${BASE}/settings`, { method: 'POST', headers: headers(token),
    body: JSON.stringify(body) });
export const getHistory = (token, params) =>
  call(`${BASE}/history?${query(params)}`, { headers: headers(token) });

export const decide = (token, id, decision, body) =>
  call(`${BASE}/actions/${encodeURIComponent(id)}/${decision}`,
    { method: 'POST', headers: headers(token), body: JSON.stringify(body || {}) });
export const approveMany = (token, ids) =>
  call(`${BASE}/approve`, { method: 'POST', headers: headers(token),
    body: JSON.stringify({ ids }) });
export const applyOne = (token, id, dryRun = true) =>
  call(`${BASE}/actions/${encodeURIComponent(id)}/apply`,
    { method: 'POST', headers: headers(token),
      body: JSON.stringify({ dry_run: dryRun }) });
export const undoOne = (token, id, dryRun = true) =>
  call(`${BASE}/actions/${encodeURIComponent(id)}/undo`,
    { method: 'POST', headers: headers(token),
      body: JSON.stringify({ dry_run: dryRun }) });
